<template>
  <div class="details" v-loading="loading">
    <div class="details-first">
      <div class="details-first-title">用户信息</div>
      <div class="details-first-table">
        <el-table
          :data="tableData"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <el-table-column prop="id" label="用户ID" width="110">
          </el-table-column>
          <el-table-column prop="phone" label="用户手机号" width="136">
          </el-table-column>
          <el-table-column prop="nickname" label="用户昵称" width="130">
          </el-table-column>

          <el-table-column
            prop="inviteUserPhone"
            label="推荐人手机号"
            width="130"
          >
          </el-table-column>
          <el-table-column label="用户类型" width="120">
            <template slot-scope="scope">
              {{
                scope.row.collaborateStatus == 1
                  ? scope.row.collaborateLevel == 1
                    ? '初级合伙人'
                    : scope.row.collaborateLevel == 2
                    ? '精英合伙人'
                    : scope.row.collaborateLevel == 3
                    ? '事业合伙人'
                    : ''
                  : '普通用户'
              }}
            </template>
          </el-table-column>
          <el-table-column label="购买VIP" width="120">
            <template slot-scope="scope">
              <div
                :style="{ color: scope.row.isVip == 0 ? '#F759AB' : '#36C100' }"
              >
                {{ scope.row.isVip == 0 ? '否' : '是' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="use_integral" label="用户可用积分" width="140">
          </el-table-column>
          <el-table-column prop="add_integral" label="用户累计积分" width="140">
          </el-table-column>
          <el-table-column prop="spend" label="累计消费金额(元)" width="144">
          </el-table-column>
          <el-table-column prop="vipSpend" label="充值消费(元)" width="144">
          </el-table-column>
          <el-table-column
            prop="shopSpend"
            label="平台购买消费(元)"
            width="144"
          >
          </el-table-column>
          <el-table-column prop="earnestMoney" label="账户余额(元)" width="160">
          </el-table-column>
          <el-table-column label="用户ID状态" width="122">
            <template slot-scope="scope">
              <div
                class="table-userStatus"
                :style="{
                  color:
                    scope.row.is_suosi_switch == 0 &&
                    scope.row.is_zhuxiao_switch == 0
                      ? '#36C100'
                      : scope.row.is_suosi_switch == 1
                      ? '#F759AB'
                      : scope.row.is_zhuxiao_switch == 1
                      ? '#999999'
                      : '',
                }"
              >
                {{
                  scope.row.is_suosi_switch == 0 &&
                  scope.row.is_zhuxiao_switch == 0
                    ? '正常使用'
                    : scope.row.is_suosi_switch == 1
                    ? '平台冻结'
                    : scope.row.is_zhuxiao_switch == 1
                    ? '用户注销'
                    : ''
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="注册时间" width="150">
          </el-table-column>
          <el-table-column prop="invitedTime" label="被推荐时间" width="150">
          </el-table-column>
          <el-table-column
            prop="inviteUserNum"
            label="邀请用户(人)"
            width="112"
          >
          </el-table-column>
          <el-table-column prop="zhifubao" label="支付宝账号" width="112">
          </el-table-column>
          <el-table-column prop="inviteCode" label="用户推荐码" width="130">
          </el-table-column>
          <el-table-column label="操作" width="96">
            <template slot-scope="scope">
              <div class="table-operation">
                <div
                  class="table-operation-right"
                  :style="{
                    color:
                      scope.row.is_suosi_switch == 0 &&
                      scope.row.is_zhuxiao_switch == 0
                        ? ''
                        : '#ED6D1F',
                  }"
                  @click="deblockingBtn(scope.row)"
                >
                  {{
                    scope.row.is_suosi_switch == 0 &&
                    scope.row.is_zhuxiao_switch == 0
                      ? '冻结'
                      : '解封'
                  }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="details-second">
      <div class="details-second-div">
        <div
          class="details-second-div-left"
          :class="{ active: headerIndex == 0 }"
          @click="headerBtn(0)"
          style="border-radius: 10px 0 0 0"
        >
          已邀请用户
        </div>
        <div
          class="details-second-div-right"
          :class="{ active: headerIndex == 1 }"
          @click="headerBtn(1)"
        >
          用户实名信息
        </div>
        <div
          class="details-second-div-right"
          :class="{ active: headerIndex == 2 }"
          @click="headerBtn(2)"
        >
          用户绑卡信息
        </div>
        <div
          class="details-second-div-right"
          :class="{ active: headerIndex == 3 }"
          @click="headerBtn(3)"
        >
          用户充值消费
        </div>
        <div
          class="details-second-div-right"
          :class="{ active: headerIndex == 4 }"
          @click="headerBtn(4)"
        >
          商品订单
        </div>
        <div
          class="details-second-div-right"
          :class="{ active: headerIndex == 5 }"
          @click="headerBtn(5)"
        >
          积分订单
        </div>

        <div
          class="details-second-div-right"
          :class="{ active: headerIndex == 6 }"
          @click="headerBtn(6)"
        >
          余额明细
        </div>

        <div
          class="details-second-div-right"
          :class="{ active: headerIndex == 7 }"
          @click="headerBtn(7)"
        >
          消费待返
        </div>
        <div
          class="details-second-div-right"
          :class="{ active: headerIndex == 8 }"
          @click="headerBtn(8)"
        >
          合伙人补贴明细
        </div>
      </div>

      <div v-if="headerIndex == 0">
        <div class="details-second-table">
          <el-table
            :data="tableList"
            border
            style="width: 100%; cursor: pointer"
            :header-cell-style="{
              color: '#333333',
              backgroundColor: '#FAFAFA   ',
            }"
            :key="isTableList"
          >
            <!-- 自定义暂无数据 -->
            <template slot="empty">
              <div class="empty-block">
                <img
                  class="empty-block-img"
                  src="../../assets/common/common-empty.png"
                />
                <div class="empty-block-text">暂无数据～</div>
              </div>
            </template>
            <el-table-column prop="id" label="用户ID" width="110">
            </el-table-column>
            <el-table-column prop="phone" label="用户手机号" width="100">
            </el-table-column>
            <el-table-column prop="nickname" label="用户昵称"></el-table-column>
            <el-table-column label="用户类型" width="180">
              <template slot-scope="scope">
                {{
                  scope.row.collaborateStatus == 1
                    ? scope.row.collaborateLevel == 1
                      ? '初级合伙人'
                      : scope.row.collaborateLevel == 2
                      ? '精英合伙人'
                      : scope.row.collaborateLevel == 3
                      ? '事业合伙人'
                      : ''
                    : '普通用户'
                }}
              </template>
            </el-table-column>
            <el-table-column label="购买VIP" width="120">
              <template slot-scope="scope">
                <div
                  :style="{
                    color: scope.row.isVip == 0 ? '#F759AB' : '#36C100',
                  }"
                >
                  {{ scope.row.isVip == 0 ? '否' : '是' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="use_integral"
              label="用户可用积分"
              width="130"
            >
            </el-table-column>
            <el-table-column
              prop="add_integral"
              label="用户累计积分"
              width="134"
            >
            </el-table-column>
            <el-table-column prop="spend" label="累计消费金额(元)" width="158">
            </el-table-column>
            <el-table-column label="用户ID状态" width="122">
              <template slot-scope="scope">
                <div
                  class="table-userStatus"
                  :style="{
                    color:
                      scope.row.is_suosi_switch == 0 &&
                      scope.row.is_zhuxiao_switch == 0
                        ? '#36C100'
                        : scope.row.is_suosi_switch == 1
                        ? '#F759AB'
                        : scope.row.is_zhuxiao_switch == 1
                        ? '#999999'
                        : '',
                  }"
                >
                  {{
                    scope.row.is_suosi_switch == 0 &&
                    scope.row.is_zhuxiao_switch == 0
                      ? '正常使用'
                      : scope.row.is_suosi_switch == 1
                      ? '平台冻结'
                      : scope.row.is_zhuxiao_switch == 1
                      ? '用户注销'
                      : ''
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="注册时间" width="276">
            </el-table-column>
          </el-table>
        </div>

        <div class="details-second-Pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="prev, pager, next, sizes"
            :total="tableTotalNum"
          >
          </el-pagination>
        </div>
      </div>

      <div v-if="headerIndex == 1">
        <div class="details-second-table">
          <el-table
            :data="userList"
            border
            style="width: 100%; cursor: pointer"
            :header-cell-style="{
              color: '#333333',
              backgroundColor: '#FAFAFA   ',
            }"
            :key="isUserList"
          >
            <!-- 自定义暂无数据 -->
            <template slot="empty">
              <div class="empty-block">
                <img
                  class="empty-block-img"
                  src="../../assets/common/common-empty.png"
                />
                <div class="empty-block-text">暂无数据～</div>
              </div>
            </template>
            <el-table-column
              prop="id"
              label="申请编号"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="nickname"
              label="用户名称"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="userhome_id"
              label="用户id"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="用户姓名"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="用户手机号"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="number"
              label="用户身份证号"
              width="230"
            ></el-table-column>
            <el-table-column label="用户身份证正面" width="113">
              <template slot-scope="scope">
                <div class="table-img" @click="previewMet1(scope.row, 0)">
                  <el-image
                    ref="preview"
                    style="width: 70px; height: 50px"
                    :src="scope.row.front_photo"
                    :preview-src-list="srcList2"
                  ></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="用户身份证反面" width="113">
              <template slot-scope="scope">
                <div class="table-img" @click="previewMet1(scope.row, 1)">
                  <el-image
                    ref="preview1"
                    style="width: 70px; height: 50px"
                    :src="scope.row.back_photo"
                    :preview-src-list="srcList3"
                  ></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="申请时间"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="updateTime"
              label="处理时间"
              width="150"
            ></el-table-column>
            <el-table-column label="审核状态" width="150">
              <template slot-scope="scope">
                <div
                  :style="{
                    color: scope.row.status == 1 ? '#36C100' : '#FF3333',
                  }"
                >
                  {{
                    scope.row.status == 0
                      ? '待审核'
                      : scope.row.status == 1
                      ? '审核通过'
                      : scope.row.status == 2
                      ? '申请驳回'
                      : ''
                  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div v-if="headerIndex == 2">
        <div class="details-second-table">
          <el-table
            :data="bankList"
            border
            style="width: 100%; cursor: pointer"
            :header-cell-style="{
              color: '#333333',
              backgroundColor: '#FAFAFA   ',
            }"
            :key="isBankList"
          >
            <!-- 自定义暂无数据 -->
            <template slot="empty">
              <div class="empty-block">
                <img
                  class="empty-block-img"
                  src="../../assets/common/common-empty.png"
                />
                <div class="empty-block-text">暂无数据～</div>
              </div>
            </template>
            <el-table-column
              prop="id"
              label="申请编号"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="nickname"
              label="申请用户"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="userhome_id"
              label="用户id"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="realname"
              label="持卡人姓名"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="银行卡预留手机号"
              width="150"
            ></el-table-column>

            <el-table-column
              prop="bank_number"
              label="持卡人卡号"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="申请时间"
              width="160"
            ></el-table-column>
            <el-table-column label="银行卡正面" width="113">
              <template slot-scope="scope">
                <div class="table-img" @click="previewMet(scope.row, 0)">
                  <el-image
                    ref="preview"
                    style="width: 70px; height: 50px"
                    :src="scope.row.front_img"
                    :preview-src-list="srcList0"
                  ></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="银行卡反面" width="113">
              <template slot-scope="scope">
                <div class="table-img" @click="previewMet(scope.row, 1)">
                  <el-image
                    ref="preview1"
                    style="width: 70px; height: 50px"
                    :src="scope.row.back_img"
                    :preview-src-list="srcList1"
                  ></el-image>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="createTime"
              label="创建时间"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="uptatetime"
              label="处理时间"
              width="150"
            ></el-table-column>
            <el-table-column label="审核状态" width="150">
              <template slot-scope="scope">
                <div
                  :style="{
                    color: scope.row.status == 1 ? '#36C100' : '#FF3333',
                  }"
                >
                  {{
                    scope.row.status == 0
                      ? '待审核'
                      : scope.row.status == 1
                      ? '审核通过'
                      : scope.row.status == 2
                      ? '申请驳回'
                      : ''
                  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div v-if="headerIndex == 3">
        <div class="details-second-sort">
          <div
            class="sort-list"
            v-for="(item, index) in memberList"
            :key="index"
          >
            <div class="sort-list-block">
              <div
                class="sort-list-commercialOdd"
                v-for="(info, num) in 7"
                :key="num"
              >
                <div class="commercialOdd-title">
                  {{
                    num == 0
                      ? '商户单号'
                      : num == 1
                      ? '交易单号'
                      : num == 2
                      ? '支付日期'
                      : num == 3
                      ? '支付方式'
                      : num == 4
                      ? '支付金额'
                      : num == 5
                      ? '会员开始时间'
                      : num == 6
                      ? '会员结束时间'
                      : ''
                  }}
                </div>
                <div class="commercialOdd-num" v-if="num != 3">
                  {{
                    num == 0
                      ? item.payCode
                      : num == 1
                      ? item.orderNum
                      : num == 2
                      ? item.createTime
                      : num == 4
                      ? item.vipPrice
                      : num == 5
                      ? item.createTime
                      : num == 6
                      ? item.endTime
                      : ''
                  }}
                </div>

                <div v-else class="commercialOdd-finish">
                  <div class="commercialOdd-finish-title">
                    {{
                      item.payType == 1
                        ? '微信支付'
                        : item.payType == 2
                        ? '支付宝支付'
                        : item.payType == 3
                        ? '立减券抵扣支付'
                        : item.payType == 4
                        ? '积分支付'
                        : item.payType == 5
                        ? '银盛微信'
                        : item.payType == 6
                        ? '银盛支付宝'
                        : item.payType == 7
                        ? '银盛网银'
                        : ''
                    }}
                  </div>
                  <img
                    class="commercialOdd-finish-img"
                    :src="
                      item.payType == 1
                        ? require('../../assets/common/common-weixin.png')
                        : item.payType == 2
                        ? require('../../assets/common/common-alipay.png')
                        : item.payType == 3
                        ? require('../../assets/common/common-integral.png')
                        : item.payType == 4
                        ? require('../../assets/common/common-discount.png')
                        : ''
                    "
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="empty-block" v-if="memberTotal == 0">
            <img
              class="empty-block-img"
              src="../../assets/common/common-empty.png"
            />
            <div class="empty-block-text">暂无数据～</div>
          </div>
        </div>

        <div class="details-second-Pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="prev, pager, next, sizes"
            :total="memberTotal"
          >
          </el-pagination>
        </div>
      </div>

      <div v-if="headerIndex == 4">
        <div class="market-second-table">
          <el-table
            ref="multipleTable"
            :data="marketData"
            tooltip-effect="dark"
            style="width: 100%"
            border=""
            @selection-change="handleSelectionChange"
            :header-cell-style="{
              color: '#333333',
              backgroundColor: '#FAFAFA',
            }"
          >
            <!-- 自定义暂无数据 -->
            <template slot="empty">
              <div class="empty-block">
                <img
                  class="empty-block-img"
                  src="../../assets/common/common-empty.png"
                />
                <div class="empty-block-text">暂无数据～</div>
              </div>
            </template>
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column label="订单号" width="200">
              <template slot-scope="scope">
                <div class="table-ordernum">
                  <div class="table-ordernum-title">
                    {{ scope.row.ordernum }}
                  </div>
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">
                      {{ scope.row.oBreak ? scope.row.oBreak : '暂无拒绝原因' }}
                    </div>
                    <img
                      v-if="scope.row.oBreak != null"
                      class="table-ordernum-img"
                      :src="
                        scope.row.breakLevel == 0
                          ? require('../../assets/home/state1.png')
                          : scope.row.breakLevel == 1
                          ? require('../../assets/home/state2.png')
                          : scope.row.breakLevel == 2
                          ? require('../../assets/home/state3.png')
                          : scope.row.breakLevel == 3
                          ? require('../../assets/home/state4.png')
                          : scope.row.breakLevel == 4
                          ? require('../../assets/home/state5.png')
                          : ''
                      "
                    />
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="paycode" label="支付单号" width="200">
            </el-table-column>
            <el-table-column prop="name" label="收件人名称" width="150">
            </el-table-column>
            <el-table-column label="收件人信息" width="206">
              <template slot-scope="scope">
                <div class="table-recipients">
                  <div class="table-recipients-phone">
                    {{ scope.row.phone }}
                  </div>
                  <div class="table-recipients-address">
                    {{ scope.row.address }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="userId"
              label="用户ID"
              width="78"
            ></el-table-column>
            <el-table-column label="用户名称" width="138">
              <template slot-scope="scope">
                <div class="table-user">
                  <div class="table-user-name">{{ scope.row.userName }}</div>
                  <div class="table-user-relation">联系他</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="订单类型" width="158">
              <template slot-scope="scope">
                <div class="table-type">
                  {{
                    scope.row.activityStatus == 0
                      ? '普通订单'
                      : scope.row.activityStatus == 10
                      ? 'VIP订单'
                      : scope.row.activityStatus == 30
                      ? '每日爆款'
                      : scope.row.activityStatus == 40
                      ? '限时秒杀'
                      : scope.row.activityStatus == 50
                      ? '福利订单'
                      : ''
                  }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="订单状态" width="110">
              <template slot-scope="scope">
                <div
                  class="table-status"
                  v-if="scope.row.is_all_shouhou == 0"
                  :style="{
                    color:
                      scope.row.status == 0
                        ? ''
                        : scope.row.status == 1
                        ? '#F9B63C'
                        : scope.row.status == 2
                        ? '#FF4133'
                        : scope.row.status == 3
                        ? '#36C100'
                        : scope.row.status == 4
                        ? ''
                        : scope.row.status == 5
                        ? '#222222'
                        : scope.row.status == 6
                        ? ''
                        : scope.row.status == 9
                        ? ''
                        : '',
                  }"
                >
                  {{
                    scope.row.status == 0
                      ? '已取消'
                      : scope.row.status == 1
                      ? '待支付'
                      : scope.row.status == 2
                      ? '已支付'
                      : scope.row.status == 3
                      ? '已发货'
                      : scope.row.status == 4
                      ? '待评价'
                      : scope.row.status == 5
                      ? '已完成'
                      : scope.row.status == 6
                      ? '售后中'
                      : scope.row.status == 9
                      ? '已删除'
                      : ''
                  }}
                </div>

                <div v-else class="table-status" style="color: #f759ab">
                  已售后
                </div>
              </template>
            </el-table-column>
            <el-table-column label="商品信息" width="278">
              <template slot-scope="scope">
                <div
                  class="table-commodity"
                  v-for="(item, index) in scope.row.order_detail_list"
                  :key="index"
                >
                  <div class="table-commodity-left">
                    <img :src="item.image" alt="" />
                  </div>
                  <div class="table-commodity-right">
                    <div class="table-commodity-right-title">
                      {{ item.name }}
                    </div>
                    <div class="table-commodity-right-text">
                      {{ item.goods_spec_name }}
                      <span style="color: #222222">x{{ item.num }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="商品总价" width="103">
              <template slot-scope="scope">
                <div class="table-commodityPrice">
                  ￥{{
                    scope.row.isVip == 0 ? scope.row.price : scope.row.vip_price
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="运费" width="90">
              <template slot-scope="scope"
                >￥{{ scope.row.freight || 0.0 }}</template
              >
            </el-table-column>
            <el-table-column prop="" label="实付款" width="90">
              <template slot-scope="scope"
                >￥{{
                  scope.row.status == 0 || scope.row.status == 1
                    ? '0.00'
                    : scope.row.allprice
                }}</template
              >
            </el-table-column>
            <el-table-column prop="" label="支付方式" width="100">
              <template slot-scope="scope">
                <div class="table-paytype">
                  <div class="table-paytype-title">
                    {{
                      scope.row.paytype == 1
                        ? '微信支付'
                        : scope.row.paytype == 2
                        ? '支付宝支付'
                        : scope.row.paytype == 3
                        ? '立减券抵扣'
                        : scope.row.paytype == 4
                        ? '积分支付'
                        : scope.row.paytype == 5
                        ? '银盛微信'
                        : scope.row.paytype == 6
                        ? '银盛支付宝'
                        : scope.row.paytype == 7
                        ? '银盛网银'
                        : ''
                    }}
                  </div>
                  <img
                    class="table-paytype-img"
                    :src="
                      scope.row.paytype == 1
                        ? require('../../assets/home/wxico.png')
                        : scope.row.paytype == 2
                        ? require('../../assets/home/zhifuico.png')
                        : index == 4
                        ? require('../../assets/home/icon_jb.png')
                        : ''
                    "
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="物流详情" width="90">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.status != 0 && scope.row.status != 1"
                  class="table-logistics"
                  @click="logisticsCheck(scope.row)"
                >
                  物流查看
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="supplierName" label="供应商名称" width="111">
            </el-table-column>
            <el-table-column prop="" label="供应商总价" width="100">
              <template slot-scope="scope"
                >￥{{ scope.row.supplier_cost }}</template
              >
            </el-table-column>
            <el-table-column prop="createTime" label="订单创建时间" width="184">
            </el-table-column>
            <el-table-column prop="payTime" label="订单支付时间" width="194">
            </el-table-column>
            <el-table-column
              prop="shouhuoTime"
              label="确认收货时间"
              width="194"
            >
            </el-table-column>
            <el-table-column prop="" label="操作" width="106" fixed="right">
              <template slot-scope="scope">
                <div class="table-operation">
                  <div
                    class="table-operation-title"
                    @click="remarkClick(scope.row)"
                  >
                    备注
                  </div>
                  <div
                    class="table-operation-title"
                    style="margin-left: 10px"
                    @click="examineClick(scope.row)"
                  >
                    查看
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="integral-second-Pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="prev, pager, next, sizes"
            :total="marketTotalNum"
          >
          </el-pagination>
        </div>

        <!--备注弹出框-->
        <div class="remark">
          <el-dialog
            :visible.sync="remarkDialogVisible"
            style="margin-top: 10vh"
            @close="remarkClose"
          >
            <span slot="footer" class="dialog-footer">
              <div class="remark-div">
                <div class="remark-div-top">
                  <div class="remark-div-top-title">订单备注</div>
                  <img
                    class="remark-div-top-img"
                    src="../../assets/common/close.png"
                    @click="remarkClose"
                  />
                </div>

                <div class="remark-div-center">
                  <div class="remark-div-center-textarea">
                    <el-input
                      type="textarea"
                      placeholder="请填写订单备注信息"
                      v-model="remarkOrdermessage"
                      maxlength=""
                      show-word-limit
                    ></el-input>
                  </div>

                  <div class="remark-div-center-display">
                    <el-radio-group v-model="remarkRadio">
                      <el-radio
                        v-for="(item, index) in 5"
                        :key="index"
                        :label="index"
                        ><img
                          class="remark-div-center-display-img"
                          :src="
                            index == 0
                              ? require('../../assets/home/state1.png')
                              : index == 1
                              ? require('../../assets/home/state2.png')
                              : index == 2
                              ? require('../../assets/home/state3.png')
                              : index == 3
                              ? require('../../assets/home/state4.png')
                              : require('../../assets/home/state5.png')
                          "
                          alt=""
                      /></el-radio>
                    </el-radio-group>
                  </div>
                </div>

                <div class="remark-div-bottom">
                  <div class="remark-div-bottom-title" @click="remarkConfirm">
                    确 定
                  </div>
                </div>
              </div>
            </span>
          </el-dialog>
        </div>

        <!-- 物流填写 -->
        <div class="logisticswrite">
          <el-dialog
            :visible.sync="logisticswriteDialogVisible"
            style="margin-top: 10vh"
            @close="logisticswriteClose"
          >
            <span slot="footer" class="dialog-footer">
              <div class="logisticswrite-div">
                <div class="logisticswrite-div-top">
                  <div class="logisticswrite-div-top-title">物流填写</div>
                  <img
                    class="logisticswrite-div-top-img"
                    src="../../assets/common/close.png"
                    @click="logisticswriteClose"
                  />
                </div>

                <div class="logisticswrite-div-center">
                  <div class="logisticswrite-div-center-display">
                    <div
                      class="logisticswrite-div-center-display-list"
                      v-for="(item, index) in 2"
                      :key="index"
                    >
                      <div class="logisticswrite-div-center-display-list-title">
                        {{ index == 0 ? '物流公司' : '物流单号' }}
                      </div>
                      <div class="logisticswrite-div-center-display-list-input">
                        <el-select
                          v-if="index == 0"
                          v-model="logisticswriteCompanyType"
                          clearable
                          placeholder="请选择"
                          @change="companyChange"
                        >
                          <el-option
                            v-for="item in logisticswriteCompanyList"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code"
                          >
                          </el-option>
                        </el-select>

                        <el-input
                          v-if="index == 1"
                          placeholder="请输入物流单号"
                          v-model="logisticswriteTracking"
                          clearable
                        ></el-input>
                      </div>
                    </div>
                  </div>

                  <div class="logisticswrite-div-center-textarea">
                    <el-input
                      type="textarea"
                      placeholder="请填写订单物流备注信息"
                      v-model="logisticswriteTrackingRemark"
                      maxlength=""
                      show-word-limit
                    ></el-input>
                  </div>
                </div>

                <div class="logisticswrite-div-bottom">
                  <div
                    class="logisticswrite-div-bottom-title"
                    @click="logisticswriteConfirm"
                  >
                    确 定
                  </div>
                </div>
              </div>
            </span></el-dialog
          >
        </div>
      </div>

      <div v-if="headerIndex == 5">
        <div class="integral-second">
          <div class="integral-second-table">
            <el-table
              ref="multipleTable"
              :data="IntegralData"
              tooltip-effect="dark"
              style="width: 100%"
              border=""
              @selection-change="handleSelectionChange"
              :header-cell-style="{
                color: '#333333',
                backgroundColor: '#FAFAFA',
              }"
            >
              <!-- 自定义暂无数据 -->
              <template slot="empty">
                <div class="empty-block">
                  <img
                    class="empty-block-img"
                    src="../../assets/common/common-empty.png"
                  />
                  <div class="empty-block-text">暂无数据～</div>
                </div>
              </template>
              <el-table-column type="selection" width="45"></el-table-column>
              <el-table-column label="订单号" width="200">
                <template slot-scope="scope">
                  <div class="table-ordernum">
                    <div class="table-ordernum-title">
                      {{ scope.row.ordernum }}
                    </div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.oBreak"
                      placement="top-start"
                    >
                      <img
                        v-if="scope.row.oBreak != null"
                        class="table-ordernum-img"
                        :src="
                          scope.row.breakLevel == 0
                            ? require('../../assets/home/state1.png')
                            : scope.row.breakLevel == 1
                            ? require('../../assets/home/state2.png')
                            : scope.row.breakLevel == 2
                            ? require('../../assets/home/state3.png')
                            : scope.row.breakLevel == 3
                            ? require('../../assets/home/state4.png')
                            : scope.row.breakLevel == 4
                            ? require('../../assets/home/state5.png')
                            : ''
                        "
                      />
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="收件人名称" width="150">
              </el-table-column>
              <el-table-column label="收件人信息" width="206">
                <template slot-scope="scope">
                  <div class="table-recipients">
                    <div class="table-recipients-phone">
                      {{ scope.row.phone }}
                    </div>
                    <div class="table-recipients-address">
                      {{ scope.row.address }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="userId"
                label="用户ID"
                width="78"
              ></el-table-column>
              <el-table-column label="用户名称" width="88">
                <template slot-scope="scope">
                  <div class="table-user">
                    <div class="table-user-name">{{ scope.row.userName }}</div>
                    <div class="table-user-relation">联系他</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="" label="订单状态" width="110">
                <template slot-scope="scope">
                  <div
                    class="table-status"
                    :style="{
                      color:
                        scope.row.status == 2
                          ? '#FF4133'
                          : scope.row.status == 3
                          ? '#36C100'
                          : scope.row.status == 5
                          ? '#222222'
                          : '',
                    }"
                  >
                    {{
                      scope.row.status == 0
                        ? '已取消'
                        : scope.row.status == 1
                        ? '待支付'
                        : scope.row.status == 2
                        ? '已支付'
                        : scope.row.status == 3
                        ? '已发货'
                        : scope.row.status == 4
                        ? '待评价'
                        : scope.row.status == 5
                        ? '已完成'
                        : scope.row.status == 6
                        ? '售后中'
                        : scope.row.status == 9
                        ? '已删除'
                        : ''
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="" label="商品信息" width="278">
                <template slot-scope="scope">
                  <div
                    class="table-commodity"
                    v-for="(item, index) in scope.row.order_detail_list"
                    :key="index"
                  >
                    <div class="table-commodity-left">
                      <img :src="item.image" alt="" />
                    </div>
                    <div class="table-commodity-right">
                      <div class="table-commodity-right-title">
                        {{ item.name }}
                      </div>
                      <div class="table-commodity-right-text">
                        {{ item.goods_spec_name }}
                        <span style="color: #222222">x{{ item.num }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="" label="商品总价" width="83">
                <template slot-scope="scope"
                  >{{ scope.row.use_integral || 0 }}积分</template
                >
              </el-table-column>
              <el-table-column prop="" label="实付款" width="90">
                <template slot-scope="scope"
                  >{{ scope.row.use_integral }}积分</template
                >
              </el-table-column>
              <el-table-column prop="" label="支付方式" width="122">
                <template slot-scope="scope">
                  <div class="table-paytype">
                    <div class="table-paytype-title">
                      {{
                        scope.row.paytype == 1
                          ? '微信支付'
                          : scope.row.paytype == 2
                          ? '支付宝支付'
                          : scope.row.paytype == 3
                          ? '立减券抵扣'
                          : scope.row.paytype == 4
                          ? '积分支付'
                          : scope.row.paytype == 5
                          ? '银盛微信'
                          : scope.row.paytype == 6
                          ? '银盛支付宝'
                          : scope.row.paytype == 7
                          ? '银盛网银'
                          : ''
                      }}
                    </div>

                    <img
                      class="table-paytype-img"
                      src="../../assets/home/icon_jb.png"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="" label="物流详情" width="90">
                <template slot-scope="scope">
                  <div
                    class="table-logistics"
                    @click="logisticsCheck(scope.row)"
                  >
                    物流查看
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="supplierName"
                label="供应商名称"
                width="111"
              >
              </el-table-column>
              <el-table-column prop="" label="供应商总价" width="100">
                <template slot-scope="scope"
                  >￥{{ scope.row.supplier_cost }}</template
                >
              </el-table-column>
              <el-table-column prop="payTime" label="兑换时间" width="184">
              </el-table-column>
              <el-table-column
                prop="shouhuoTime"
                label="确认收货时间"
                width="194"
              >
              </el-table-column>
              <el-table-column prop="" label="操作" width="106" fixed="right">
                <template slot-scope="scope">
                  <div class="table-operation">
                    <div
                      class="table-operation-title"
                      @click="remarkClick(scope.row)"
                    >
                      备注
                    </div>
                    <div
                      class="table-operation-title"
                      style="margin-left: 10px"
                      @click="examineClick(scope.row)"
                    >
                      查看
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="integral-second-Pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="10"
              layout="prev, pager, next, sizes"
              :total="marketTotalNum"
            >
            </el-pagination>
          </div>
        </div>

        <!--备注弹出框-->
        <div class="remark">
          <el-dialog
            :visible.sync="remarkDialogVisible"
            style="margin-top: 10vh"
            @close="remarkClose"
          >
            <span slot="footer" class="dialog-footer">
              <div class="remark-div">
                <div class="remark-div-top">
                  <div class="remark-div-top-title">订单备注</div>
                  <img
                    class="remark-div-top-img"
                    src="../../assets/common/close.png"
                    @click="remarkClose"
                  />
                </div>

                <div class="remark-div-center">
                  <div class="remark-div-center-textarea">
                    <el-input
                      type="textarea"
                      placeholder="请填写订单备注信息"
                      v-model="remarkOrdermessage"
                      maxlength=""
                      show-word-limit
                    ></el-input>
                  </div>

                  <div class="remark-div-center-display">
                    <el-radio-group v-model="remarkRadio">
                      <el-radio
                        v-for="(item, index) in 5"
                        :key="index"
                        :label="index"
                        ><img
                          class="remark-div-center-display-img"
                          :src="
                            index == 0
                              ? require('../../assets/home/state1.png')
                              : index == 1
                              ? require('../../assets/home/state2.png')
                              : index == 2
                              ? require('../../assets/home/state3.png')
                              : index == 3
                              ? require('../../assets/home/state4.png')
                              : require('../../assets/home/state5.png')
                          "
                          alt=""
                      /></el-radio>
                    </el-radio-group>
                  </div>
                </div>

                <div class="remark-div-bottom">
                  <div class="remark-div-bottom-title" @click="remarkConfirm">
                    确 定
                  </div>
                </div>
              </div>
            </span>
          </el-dialog>
        </div>

        <!-- 物流填写 -->
        <div class="logisticswrite">
          <el-dialog
            :visible.sync="logisticswriteDialogVisible"
            style="margin-top: 10vh"
            @close="logisticswriteClose"
          >
            <span slot="footer" class="dialog-footer">
              <div class="logisticswrite-div">
                <div class="logisticswrite-div-top">
                  <div class="logisticswrite-div-top-title">物流填写</div>
                  <img
                    class="logisticswrite-div-top-img"
                    src="../../assets/common/close.png"
                    @click="logisticswriteClose"
                  />
                </div>

                <div class="logisticswrite-div-center">
                  <div class="logisticswrite-div-center-display">
                    <div
                      class="logisticswrite-div-center-display-list"
                      v-for="(item, index) in 2"
                      :key="index"
                    >
                      <div class="logisticswrite-div-center-display-list-title">
                        {{ index == 0 ? '物流公司' : '物流单号' }}
                      </div>
                      <div class="logisticswrite-div-center-display-list-input">
                        <el-select
                          v-if="index == 0"
                          v-model="logisticswriteCompanyType"
                          clearable
                          placeholder="请选择"
                          @change="companyChange"
                        >
                          <el-option
                            v-for="item in logisticswriteCompanyList"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code"
                          >
                          </el-option>
                        </el-select>

                        <el-input
                          v-if="index == 1"
                          placeholder="请输入物流单号"
                          v-model="logisticswriteTracking"
                          clearable
                        ></el-input>
                      </div>
                    </div>
                  </div>

                  <div class="logisticswrite-div-center-textarea">
                    <el-input
                      type="textarea"
                      placeholder="请填写订单物流备注信息"
                      v-model="logisticswriteTrackingRemark"
                      maxlength=""
                      show-word-limit
                    ></el-input>
                  </div>
                </div>

                <div class="logisticswrite-div-bottom">
                  <div
                    class="logisticswrite-div-bottom-title"
                    @click="logisticswriteConfirm"
                  >
                    确 定
                  </div>
                </div>
              </div>
            </span></el-dialog
          >
        </div>
      </div>

      <div v-if="headerIndex == 6">
        <div class="details-second-table">
          <el-table
            :data="balanceList"
            border
            style="width: 100%; cursor: pointer"
            :header-cell-style="{
              color: '#333333',
              backgroundColor: '#FAFAFA   ',
            }"
          >
            <!-- 自定义暂无数据 -->
            <template slot="empty">
              <div class="empty-block">
                <img
                  class="empty-block-img"
                  src="../../assets/common/common-empty.png"
                />
                <div class="empty-block-text">暂无数据～</div>
              </div>
            </template>
            <el-table-column prop="sourceUserId" label="用户ID"> </el-table-column>
            <el-table-column prop="" label="余额来源">
              <template slot-scope="scope">
                {{
                  scope.row.type == -1
                    ? '提现'
                    : scope.row.type == 0
                    ? '消费返利'
                    : scope.row.type == 1
                    ? '合伙人补贴'
                    : scope.row.type == 2
                    ? '消费补贴'
                    : scope.row.type == 3
                    ? '取消提现'
                    : scope.row.type == 4
                    ? '消费返利'
                    : scope.row.type == 5
                    ? '推广补贴'
                    : scope.row.type == 6
                    ? '合伙人差额补贴'
                    : scope.row.type == 7
                    ? '邀请好友奖励'
                    : ''
                }}
              </template>
            </el-table-column>
            <el-table-column prop="" label="支付金额（元）">
              <template slot-scope="scope">
                {{ scope.row.type == -1 ? '-' : '' }}
                {{ scope.row.price }}
              </template>
            </el-table-column>
            <el-table-column prop="consumePrice" label="账户余额（元）">
            </el-table-column>
            <el-table-column prop="receiptTime" label="余额时间">
            </el-table-column>
          </el-table>
        </div>

        <div class="details-second-Pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="prev, pager, next, sizes"
            :total="userTotalNum"
          >
          </el-pagination>
        </div>
      </div>

      <div v-if="headerIndex == 7">
        <div class="details-second-table">
          <el-table
            :data="consumerRebatesList"
            border
            style="width: 100%; cursor: pointer"
            :header-cell-style="{
              color: '#333333',
              backgroundColor: '#FAFAFA   ',
            }"
          >
            <!-- 自定义暂无数据 -->
            <template slot="empty">
              <div class="empty-block">
                <img
                  class="empty-block-img"
                  src="../../assets/common/common-empty.png"
                />
                <div class="empty-block-text">暂无数据～</div>
              </div>
            </template>
            <el-table-column prop="userId" label="用户ID"> </el-table-column>
            <el-table-column prop="" label="消费来源">
              <template slot-scope="scope">
                {{
                  scope.row.type == -1
                    ? '提现'
                    : scope.row.type == 0
                    ? '消费返利'
                    : scope.row.type == 1
                    ? '合伙人补贴'
                    : scope.row.type == 2
                    ? '消费补贴'
                    : scope.row.type == 3
                    ? '取消提现'
                    : scope.row.type == 4
                    ? '消费返利'
                    : scope.row.type == 5
                    ? '推广补贴'
                    : scope.row.type == 6
                    ? '合伙人差额补贴'
                    : scope.row.type == 7
                    ? '邀请好友奖励'
                    : ''
                }}
              </template>
            </el-table-column>
            <el-table-column prop="price" label="消费金额（元）">
            </el-table-column>
            <el-table-column prop="consumePrice" label="账户余额（元）">
            </el-table-column>
            <el-table-column prop="" label="消费状态">
              <template slot-scope="scope">
                <div
                  :style="{
                    color:
                      scope.row.status == 'ENTER'
                        ? '#36C100'
                        : scope.row.status == 'WAIT'
                        ? '#999999'
                        : '#ED6D1F',
                  }"
                >
                  {{
                    scope.row.status == 'ENTER'
                      ? '已入账'
                      : scope.row.status == 'WAIT'
                      ? '待入账'
                      : scope.row.status == 'PAST'
                      ? '已过期'
                      : ''
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="receiptTime" label="消费时间">
            </el-table-column>
          </el-table>
        </div>

        <div class="details-second-Pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="prev, pager, next, sizes"
            :total="userTotalNum"
          >
          </el-pagination>
        </div>
      </div>

      <div v-if="headerIndex == 8">
        <div class="details-second-table">
          <el-table
            :data="subsidyList"
            border
            style="width: 100%; cursor: pointer"
            :header-cell-style="{
              color: '#333333',
              backgroundColor: '#FAFAFA   ',
            }"
          >
            <!-- 自定义暂无数据 -->
            <template slot="empty">
              <div class="empty-block">
                <img
                  class="empty-block-img"
                  src="../../assets/common/common-empty.png"
                />
                <div class="empty-block-text">暂无数据～</div>
              </div>
            </template>
            <el-table-column prop="userId" label="用户ID"> </el-table-column>
            <el-table-column prop="" label="消费来源">
              <template slot-scope="scope">
                {{
                  scope.row.type == -1
                    ? '提现'
                    : scope.row.type == 0
                    ? '消费返利'
                    : scope.row.type == 1
                    ? '合伙人补贴'
                    : scope.row.type == 2
                    ? '消费补贴'
                    : scope.row.type == 3
                    ? '取消提现'
                    : scope.row.type == 4
                    ? '消费返利'
                    : scope.row.type == 5
                    ? '推广补贴'
                    : scope.row.type == 6
                    ? '合伙人差额补贴'
                    : scope.row.type == 7
                    ? '邀请好友奖励'
                    : ''
                }}
              </template>
            </el-table-column>
            <el-table-column prop="price" label="消费金额（元）">
            </el-table-column>
            <el-table-column prop="consumePrice" label="账户余额（元）">
            </el-table-column>
            <el-table-column prop="receiptTime" label="补贴时间">
            </el-table-column>
          </el-table>
        </div>

        <div class="details-second-Pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="prev, pager, next, sizes"
            :total="userTotalNum"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 冻结/解封 -->
    <div class="freeze">
      <el-dialog
        :visible.sync="quitDialogVisible"
        width="394px"
        style="margin-top: 15vh"
        :show-close="false"
      >
        <span slot="footer" class="dialog-footer">
          <div class="freeze-div">
            <img
              class="freeze-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="freeze-div-title">
              {{
                freezeShow == false
                  ? '请确定是否冻结该ID？'
                  : '请确定是否解封该ID？'
              }}
            </div>
            <div class="freeze-div-text">
              {{
                freezeShow == false
                  ? '一旦确定后，则该用户id进行冻结，用户无法进行登录并且无法进行任何操作。'
                  : '一旦确定后，则该用户id进行解封，用户进行登录并且进行任何操作。'
              }}
            </div>
            <div class="freeze-div-button">
              <div class="freeze-div-button-left" @click="quitRegister">
                确定
              </div>
              <div
                class="freeze-div-button-right"
                @click="quitDialogVisible = false"
              >
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Bus from '../../utils/bus' // bus发送跳转关闭临时组件

import {
  getuserParticulars,
  getuserInviteList,
  getuserMemberRecharge,
  getuserDeblocking,
  getusermyearnestList,
  getusermyconsumerRebates,
  getusermySubsidyList,
} from '../../api/user'

import {
  getIntegral,
  getOrderlist,
  postOrderremark,
  getLogisticscompany,
  postShipments,
  getAfterlogistics,
} from '../../api/order'

import { getBankInfo, getAuthentication } from '../../api/partenr'

export default {
  data() {
    return {
      /* 第一区域 */
      // 获取上一级页面传递id
      id: '',
      // 表格 数组
      tableData: [],

      /*  第二区域 */
      // 头部点击获取切换
      headerIndex: 0,
      // 表格数组
      tableList: [],
      // 表格数据总条数
      tableTotalNum: 0,
      // 会员充值数组列表
      memberList: [],
      // 会员充值数组总条数
      memberTotal: 0,

      // 个人信息
      userList: [],
      userTatolnum: 0,
      // 银行卡数组
      bankList: [],
      bankTatolnum: 0,
      // 监听用户刷新
      loading: false,
      // 表格页数
      page: 1,
      // 表格每页条数
      limit: 10,
      // 弹出框冻结/解封  开启
      quitDialogVisible: false,
      // 获取当前列表点击的id存储
      itemId: '',
      // 获取当前列表点击的是否冻结还是解封
      freezeShow: false,
      isTableList: false,
      isUserList: false,
      isBankList: false,
      srcList0: [],
      srcList1: [],
      srcList2: [],
      srcList3: [],
      //----------   商品订单
      marketTotalNum: 0,
      multipleSelection: [],
      marketData: [],
      // 备注弹出框  开启
      remarkDialogVisible: false,
      // 备注弹出框 单选
      remarkRadio: 0,
      // 备注弹出框  备注信息填写
      remarkOrdermessage: '',
      // 备注弹出框 当前这条订单的对象
      remarkObj: {},
      // 物流弹出框 当前这条订单的对象
      logisticsObj: {},
      // 物流弹出框 填写 开启
      logisticswriteDialogVisible: false,
      // 物流弹出框 填写 物流公司
      logisticswriteCompanyType: '',
      logisticswriteCompanyList: [],
      // 物流弹出框 填写 物流单号
      logisticswriteTracking: '',
      // 物流弹出框 填写 物流单号备注
      logisticswriteTrackingRemark: '',
      // 物流弹出框 填写 物流公司选中对象
      logisticswriteCompanyObj: {},
      IntegralData: [],

      //----------------------
      balanceList: [],
      consumerRebatesList: [],
      subsidyList: [],
      userTotalNum: 0,
    }
  },
  created() {
    this.id = this.$route.query.id
    // 请求用户详情数据
    this.getuserDetail()
    // 请求用户邀请列表数据
    this.getuserInvite()
  },
  // 控制页面刷新或者挂载完后进行权限开启
  updated() {
    if (this.id == undefined) {
      Bus.$emit('detele', 'userDetails')
    }
  },
  mounted() {
    this.loading = true
  },
  methods: {
    // 获取用户详情数据
    getuserDetail() {
      let params = this.id
      getuserParticulars(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取表格对象
          let obj = res.resultData
          this.tableData.push(obj)
          // 页面刷新
          this.loading = false
        }
      })
    },
    // 获取用户邀请列表数据
    getuserInvite() {
      let params = {
        userId: this.id,
        pageSize: this.limit,
        pageNo: this.page,
      }

      getuserInviteList(params).then((res) => {
        if (res.resultStatus == true) {
          this.tableList = res.resultData.userList
          this.isTableList = !this.isTableList
          // 获取列表总条数
          this.tableTotalNum = res.resultData.totalNum
          // 页面刷新
          this.loading = false
        }
      })
    },
    // 获取会员充值接口数据
    getuserMember() {
      let params = {
        userId: this.id,
        pageSize: this.limit,
        pageNo: this.page,
      }

      getuserMemberRecharge(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取会员列表数组
          this.memberList = res.resultData.vipList
          // 获取会员列表总条数
          this.memberTotal = res.resultData.totalNum
          // 页面刷新
          this.loading = false
        }
      })
    },
    // 用户点击切换头部标题
    headerBtn(index) {
      console.log('获取index', index)

      this.loading = true
      this.headerIndex = index
      this.userList = []
      this.tableList = []
      this.memberList = []
      this.bankList = []

      this.page = 1
      this.limit = 10
      // 用户点击切换获取会员充值
      if (index == 0) {
        this.$nextTick(() => {
          this.getuserInvite()
        })
      } else if (index == 1) {
        this.$nextTick(() => {
          this.getAuthenticationMet()
        })
      } else if (index == 2) {
        this.$nextTick(() => {
          this.getBankInfoMet()
        })
      } else if (index == 3) {
        this.$nextTick(() => {
          this.getuserMember()
        })
      } else if (index == 4) {
        this.$nextTick(() => {
          this.getOrderlistClick()
        })
      } else if (index == 5) {
        this.$nextTick(() => {
          this.getIntegralClick()
        })
      } else if (index == 6) {
        this.$nextTick(() => {
          this.getusermyearnestListMet()
        })
      } else if (index == 7) {
        this.$nextTick(() => {
          this.getusermyconsumerRebatesMet()
        })
      } else if (index == 8) {
        this.$nextTick(() => {
          this.getusermySubsidyListMet()
        })
      }
    },
    // 获取用户身份证信息
    getAuthenticationMet() {
      let params = {
        userId: this.id,
        phone: '',
        nickname: '',
        status: 1,
        createStartTime: '',
        createEndTime: '',
        pageNo: this.page,
        pageSize: this.limit,
      }

      getAuthentication(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取表格数组
          this.userList = res.resultData.list
          this.isUserList = !this.isUserList
          // 获取总数
          this.userTatolnum = res.resultData.totalNum
          this.loading = false
        }
      })
    },

    // 银行卡信息
    getBankInfoMet() {
      let params = {
        userId: this.id,
        phone: '',
        name: '',
        status: 1,
        type: 0,
        createStartTime: '',
        createEndTime: '',
        pageNo: this.page,
        pageSize: this.limit,
      }

      getBankInfo(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取表格数组
          this.bankList = res.resultData.list
          this.isBankList = !this.isBankList
          // 获取总数
          this.bankTatolnum = res.resultData.totalNum
          this.loading = false
        }
      })
    },

    // 操作   解封 冻结
    deblockingBtn(item) {
      console.log('获取当前点击的列表id', item)
      this.itemId = item.id
      this.freezeShow =
        item.is_suosi_switch == 0 && item.is_zhuxiao_switch == 0 ? false : true
      this.quitDialogVisible = true
    },
    // 用户冻结或者解封弹框确认
    quitRegister() {
      console.log('用户点击确认')
      // 获取用户解封数据
      let params = this.itemId
      getuserDeblocking(params).then((res) => {
        if (res.resultStatus == true) {
          console.log('解封数据', res)
          this.$message.success(
            this.freezeShow == false ? '冻结成功' : '解封成功'
          )
          this.loading = true
          this.tableData = []
          // 请求用户详情数据
          this.getuserDetail()
          // 请求用户邀请列表数据
          this.getuserInvite()
          this.quitDialogVisible = false
        }
      })
    },

    // 查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      console.log(`每页 ${val} 条`)
      if (this.headerIndex == 0) {
        this.getuserInvite()
      } else if (this.headerIndex == 3) {
        this.getuserMember()
      } else if (this.headerIndex == 4) {
        this.getOrderlistClick()
      } else if (this.headerIndex == 5) {
        this.getIntegralClick()
      } else if (this.headerIndex == 6) {
        this.getusermyearnestListMet()
      } else if (this.headerIndex == 7) {
        this.getusermyconsumerRebatesMet()
      } else if (this.headerIndex == 8) {
        this.getusermySubsidyListMet()
      }
    },
    // 查询当前页
    handleCurrentChange(val) {
      console.log('点基础法')
      this.page = val

      this.loading = true
      console.log(`当前页: ${val}`)
      if (this.headerIndex == 0) {
        this.getuserInvite()
      } else if (this.headerIndex == 3) {
        this.getuserMember()
      } else if (this.headerIndex == 4) {
        this.getOrderlistClick()
      } else if (this.headerIndex == 5) {
        this.getIntegralClick()
      } else if (this.headerIndex == 6) {
        this.getusermyearnestListMet()
      } else if (this.headerIndex == 7) {
        this.getusermyconsumerRebatesMet()
      } else if (this.headerIndex == 8) {
        this.getusermySubsidyListMet()
      }
    },

    previewMet(item, index) {
      console.log('触发', item, index)

      if (index == 0) {
        this.srcList0.push(item.front_img)
        this.$refs.preview.clickHandler()
      } else {
        this.srcList1.push(item.back_img)
        this.$refs.preview1.clickHandler()
      }
    },
    previewMet1(item, index) {
      if (index == 0) {
        this.srcList2.push(item.front_photo)
        this.$refs.preview.clickHandler()
      } else {
        this.srcList3.push(item.back_photo)
        this.$refs.preview1.clickHandler()
      }
    },

    // 商品订单
    getOrderlistClick() {
      let params = {
        userId: this.id,
        userName: '',
        userPhone: '',
        supplierName: '',
        wuliu_num: '',
        name: '',
        phone: '',
        address: '',
        ordernum: '',
        status: '',
        paytype: '',
        activityStatus: '',
        createStartTime: '',
        createEndTime: '',
        payStartTime: '',
        payEndTime: '',
        shouStartTime: '',
        shouEndTime: '',
        paycode: '',
        shouhou_wuliu_no: '',
        is_shouhou: '',
        pageSize: this.limit,
        pageNo: this.page,
      }

      getOrderlist(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取数据表格
          this.marketData = res.resultData.orderList
          // 获取总条数
          this.marketTotalNum = res.resultData.totalNum
          // 关闭刷新
          this.loading = false
        }
      })
    },
    // 表格区域点击选中 勾选对应的
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 备注旗帜点击
    remarkClick(e) {
      this.remarkObj = e
      this.remarkOrdermessage = e.oBreak
      this.remarkRadio = e.breakLevel
      this.remarkDialogVisible = true
    },
    // 操作 点击查看跳转详情
    examineClick(e) {
      this.$router.push({
        path: '/marketOrderdetail',
        query: {
          orderId: e.id,
        },
      })
    },
    // 备注旗帜点击 关闭
    remarkClose() {
      this.remarkOrdermessage = ''
      this.remarkRadio = 0
      this.remarkDialogVisible = false
    },
    // 备注弹出框 确定
    remarkConfirm() {
      if (this.remarkOrdermessage == '') {
        this.$message({
          message: '抱歉，必须填写对应的订单备注！',
          type: 'warning',
          duration: 1500,
        })
        return
      }

      let params = {
        orderId: this.remarkObj.id, //  订单id
        breakLevel: this.remarkRadio, // 备注级别
        oBreak: this.remarkOrdermessage, // 备注
      }

      postOrderremark(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '填写成功！',
            type: 'success',
            duration: 1500,
          })
          this.loading = true
          this.remarkClose()
          if (this.headerIndex == 4) {
            this.getOrderlistClick()
          } else if (this.headerIndex == 5) {
            this.getIntegralClick()
          }
        }
      })
    },

    // 物流弹出框  填写查看
    logisticsCheck(e) {
      this.logisticsObj = e
      this.getLogisticscompanyClick()
    },
    // 获取物流公司
    getLogisticscompanyClick() {
      let params = {}

      getLogisticscompany(params).then((res) => {
        if (res.resultStatus == true) {
          this.logisticswriteCompanyList = res.resultData
          this.logisticswriteDialogVisible = true
          // 获取公司进行筛选
          this.getLogisticsdetail()
        }
      })
    },

    getLogisticsdetail() {
      let params = {
        orderId: this.logisticsObj.id,
      }

      getAfterlogistics(params).then((res) => {
        if (res.resultStatus == true) {
          if (res.resultData == null) {
            return
          }
          // 物流单号
          this.logisticswriteTracking = res.resultData.wuliu_num
          // 物流备注
          this.logisticswriteTrackingRemark = res.resultData.break
          // 物流公司
          this.logisticswriteCompanyList.forEach((item, index) => {
            if (res.resultData.wuliu_name == item.name) {
              this.logisticswriteCompanyObj = item
              this.logisticswriteCompanyType = item.name
            }
          })
        }
      })
    },

    // 物流填写弹出框  关闭
    logisticswriteClose() {
      this.logisticswriteDialogVisible = false
    },
    // 物流填写弹出框 下拉勾选
    companyChange(e) {
      this.logisticswriteCompanyList.forEach((item, index) => {
        if (e == item.code) {
          this.logisticswriteCompanyObj = item
        }
      })
    },
    // 物流填写弹出框  确定
    logisticswriteConfirm() {
      let params = {
        orderId: this.logisticsObj.id, // 订单id
        wuliu_code: this.logisticswriteCompanyObj.code, // 物流公司编码
        wuliu_name: this.logisticswriteCompanyObj.name, // 物流名称
        wuliu_num: this.logisticswriteTracking, // 物流单号
        break: this.logisticswriteTrackingRemark, // 备注
      }
      postShipments(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '物流填写成功！',
            type: 'success',
            duration: 1500,
          })
          this.logisticswriteCompanyType = ''
          this.logisticswriteTracking = ''
          this.logisticswriteTrackingRemark = ''

          this.loading = true
          this.logisticswriteDialogVisible = false
          this.getOrderlistClick()
        }
      })
    },
    //--------------------------------------------------
    // 获取积分订单列表数据
    getIntegralClick() {
      let params = {
        userId: this.id, // 用户id
        userName: '', // 用户名称
        userPhone: '', // 用户电话
        supplierName: '', // 供应商名称
        wuliu_num: '', // 物流单号
        name: '', // 收件人
        phone: '', // 收件人电话
        address: '', // 收货地址
        ordernum: '', // 订单号
        status: '', // 订单状态 支付状态:0=已取消,1=待支付,2=已支付,3=已发货,4=待评价,5=已完成，6=售后中,9=已删除
        createStartTime: '', // 创建开始时间 时间戳秒
        createEndTime: '', // 创建结束时间 时间戳秒
        shouStartTime: '', // 收货开始时间 时间戳秒
        shouEndTime: '', // 收货结束时间 时间戳秒
        pageSize: this.limit, // 页码
        pageNo: this.page, // 页数
      }

      getIntegral(params).then((res) => {
        console.log('获取积分订单列表数据', res)
        if (res.resultStatus == true) {
          // 获取数据表格
          this.IntegralData = res.resultData.orderList
          // 获取总条数
          this.marketTotalNum = res.resultData.totalNum
          // 关闭刷新
          this.loading = false
        }
      })
    },

    //-------------------------------------收益列表
    getusermyearnestListMet() {
      let params = {
        userId: this.id,
        pageSize: this.limit, // 页码
        pageNo: this.page, // 页数
      }

      getusermyearnestList(params).then((res) => {
        if (res.resultStatus == true) {
          this.balanceList = res.resultData.list
          // 获取总条数
          this.userTotalNum = res.resultData.totalNum
          // 关闭刷新
          this.loading = false
        }
      })
    },
    //-----------------------消费待返
    getusermyconsumerRebatesMet() {
      let params = {
        userId: this.id,
        pageSize: this.limit, // 页码
        pageNo: this.page, // 页数
      }

      getusermyconsumerRebates(params).then((res) => {
        if (res.resultStatus == true) {
          this.consumerRebatesList = res.resultData.list
          // 获取总条数
          this.userTotalNum = res.resultData.totalNum
          // 关闭刷新
          this.loading = false
        }
      })
    },
    //-----------------------合伙人补贴
    getusermySubsidyListMet() {
      let params = {
        userId: this.id,
        pageSize: this.limit, // 页码
        pageNo: this.page, // 页数
      }

      getusermySubsidyList(params).then((res) => {
        if (res.resultStatus == true) {
          this.subsidyList = res.resultData.list
          // 获取总条数
          this.userTotalNum = res.resultData.totalNum
          // 关闭刷新
          this.loading = false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.details {
  .details-first {
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 24px;
    padding-top: 0;
    box-sizing: border-box;

    .details-first-title {
      width: 100%;
      height: 68px;
      line-height: 68px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #222222;
    }

    .details-first-table {
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #fafafa;
      }

      /deep/ .el-table tr {
        height: 45px;
      }

      .table-userStatus {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }

      .table-operation {
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;

        .table-operation-right {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
        }
      }
    }
  }

  .details-second {
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    margin-top: 20px;

    .details-second-div {
      height: 54px;
      background: #e9edf4;
      border-radius: 10px 10px 0px 0px;
      display: flex;

      .details-second-div-left,
      .details-second-div-right {
        width: 130px;
        height: 54px;
        background: #dadfe7;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        text-align: center;
        line-height: 54px;
        cursor: pointer;
      }

      .active {
        background: #ffffff;
        font-weight: 600;
      }
    }

    /* 邀请好友查看区域 */
    .details-second-table {
      padding: 14px 24px;
      box-sizing: border-box;

      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #fafafa;
      }

      /deep/ .el-table tr {
        height: 45px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;

        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }

      .table-img {
        height: 70px;
        background: #f0f0f0;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 70px;
          height: 53px;
        }
      }

      .table-userStatus {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }

      .table-operation {
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;

        .table-operation-right {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
        }
      }
    }

    .details-second-Pagination {
      height: 88px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      /deep/ .el-pagination .btn-prev {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination .btn-next {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        line-height: 32px;
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }

      /deep/ .el-pager li.active {
        background: #000000;
        color: #ffffff;
      }

      /deep/ .el-input--mini .el-input__inner {
        height: 32px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }

    /* 会员 充值消费区域 */
    .details-second-sort {
      min-height: 500px;
      padding: 0 24px;
      box-sizing: border-box;

      .sort-list {
        width: 100%;
        height: 90px;
        border-bottom: 1px solid #e9edf4;
        display: flex;
        align-items: center;
        cursor: pointer;

        .sort-list-block {
          width: 100%;
          display: flex;
          justify-content: space-between;

          .sort-list-commercialOdd {
            width: 200px;
            margin-right: 20px;

            .commercialOdd-title {
              height: 17px;
              font-size: 12px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 300;
              color: #999999;
              line-height: 17px;
            }

            .commercialOdd-num {
              height: 22px;
              font-size: 14px;
              font-weight: 300;
              color: #222222;
              line-height: 22px;
              margin-top: 4px;
            }

            .commercialOdd-finish {
              width: 100%;
              height: 22px;
              align-items: center;
              display: flex;
              margin-top: 4px;

              .commercialOdd-finish-title {
                font-size: 14px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 300;
                color: #222222;
              }

              .commercialOdd-finish-img {
                width: 20px;
                height: 20px;
                margin-left: 8px;
              }
            }
          }

          .sort-list-commercialOdd:last-child {
            margin-right: 0;
          }
        }
      }

      .sort-list:last-child {
        border-bottom: 0;
      }
    }

    .empty-block {
      margin-top: 62px;
      text-align: center;

      .empty-block-img {
        width: 130px;
        height: 130px;
        margin: 0 auto;
      }

      .empty-block-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-top: 10px;
        height: 17px;
        line-height: 17px;
      }
    }

    // 商品订单

    .market-second-table {
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table td.el-table__cell div {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      /deep/ .el-table__cell {
        vertical-align: top;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;

        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }

      .table-ordernum {
        .table-ordernum-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-ordernum-img {
          margin-top: 9px;
          width: 15px;
          height: 16px;
          cursor: pointer;
        }
      }

      .table-recipients {
        .table-recipients-phone {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-recipients-address {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          line-height: 22px;
          margin-top: 5px;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      .table-user {
        .table-user-name {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-user-relation {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .table-status {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }

      .table-commodity {
        display: flex;
        align-content: center;
        margin-bottom: 10px;

        .table-commodity-left {
          width: 70px;
          height: 70px;
          border: 1px solid #ccc;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .table-commodity-right {
          width: 196px;
          margin-left: 12px;

          .table-commodity-right-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
            line-height: 22px;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .table-commodity-right-text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
            margin-top: 4px;
          }
        }
      }

      .table-commodity:last-child {
        margin-bottom: 0;
      }

      .table-commodityPrice {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
        margin-bottom: 4px;
      }

      .table-commodityPrice:last-child {
        margin-bottom: 0;
      }

      .table-paytype {
        .table-paytype-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-paytype-img {
          width: 34px;
          height: 34px;
          margin-top: 7px;
        }
      }

      .table-operation {
        display: flex;
        align-items: center;

        .table-operation-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .table-logistics {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2aa4ff;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .integral-second-Pagination {
      height: 88px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      /deep/ .el-pagination .btn-prev {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination .btn-next {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        line-height: 32px;
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }

      /deep/ .el-pager li.active {
        background: #000000;
        color: #ffffff;
      }

      /deep/ .el-input--mini .el-input__inner {
        height: 32px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }

    // 备注弹出框
    .remark {
      /deep/ .el-dialog {
        width: 444px;
        height: 340px;
        background: #ffffff;
        box-shadow: 0px 12px 48px 16px rrgba(134, 77, 77, 0.03) 0px 9px 28px 0px
            rgba(0, 0, 0, 0.05),
          0px 6px 16px -8px rgba(0, 0, 0, 0.08);
        border-radius: 10px;
      }

      /deep/ .el-dialog__footer {
        padding: 0;
        text-align: left;
      }

      .remark-div {
        .remark-div-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 56px;
          padding: 0 24px;
          box-sizing: border-box;
          border-bottom: 1px solid #d9d9d9;

          .remark-div-top-title {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #222222;
          }

          .remark-div-top-img {
            width: 10px;
            height: 10px;
          }
        }

        .remark-div-center {
          margin: 0 24px;
          margin-top: 21px;

          .remark-div-center-textarea {
            height: 152px;
            background: #ffffff;
            border-radius: 5px;

            /deep/ .el-textarea {
              height: 152px;
              cursor: pointer;
            }

            /deep/ .el-textarea__inner {
              height: 152px;
              cursor: pointer;
              padding: 10px 10px 20px;
            }

            /deep/ .el-textarea .el-textarea__inner {
              // 然后找到对应的类名，在这里将拉伸去掉即可
              resize: none;
            }
          }

          .remark-div-center-display {
            margin-top: 11px;

            .remark-div-center-display-img {
              width: 15px;
              height: 16px;
              margin-left: 8px;
            }

            /deep/ .el-radio__label {
              padding-left: 0;
            }

            /deep/ .el-radio-group {
              font-size: 0;
              display: flex;
              align-items: center;
              justify-content: space-around;
            }

            /deep/ .el-radio__input {
              vertical-align: revert;
            }
          }
        }

        .remark-div-bottom {
          display: flex;
          height: 52px;
          align-items: center;
          justify-content: flex-end;
          padding: 0 16px;
          box-sizing: border-box;
          border-top: 1px solid #d9d9d9;
          margin-top: 32px;

          .remark-div-bottom-title {
            width: 65px;
            height: 32px;
            background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
            border-radius: 10px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
          }
        }
      }
    }

    // 物流填写弹出框
    .logisticswrite {
      /deep/ .el-dialog {
        width: 444px;
        height: 370px;
        background: #ffffff;
        box-shadow: 0px 12px 48px 16px rrgba(134, 77, 77, 0.03) 0px 9px 28px 0px
            rgba(0, 0, 0, 0.05),
          0px 6px 16px -8px rgba(0, 0, 0, 0.08);
        border-radius: 10px;
      }

      /deep/ .el-dialog__footer {
        padding: 0;
        text-align: left;
      }

      .logisticswrite-div {
        .logisticswrite-div-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 56px;
          padding: 0 24px;
          box-sizing: border-box;
          border-bottom: 1px solid #d9d9d9;

          .logisticswrite-div-top-title {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #222222;
          }

          .logisticswrite-div-top-img {
            width: 10px;
            height: 10px;
          }
        }

        .logisticswrite-div-center {
          padding: 20px 0;
          box-sizing: border-box;
          margin: 0 24px;

          .logisticswrite-div-center-display {
            display: flex;
            justify-content: space-between;

            .logisticswrite-div-center-display-list {
              .logisticswrite-div-center-display-list-title {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }

              .logisticswrite-div-center-display-list-input {
                margin-top: 4px;

                /deep/ .el-input {
                  height: 32px;
                  width: 180px;
                }

                /deep/ .el-input__inner {
                  padding: 0 10px;
                  box-sizing: border-box;
                  height: 32px;
                  background-color: rgba(255, 255, 255, 0);
                }

                /deep/ .el-select .el-input.is-focus .el-input__inner {
                  border-color: rgba(217, 217, 217, 1);
                }
              }
            }
          }

          .logisticswrite-div-center-textarea {
            height: 152px;
            background: #ffffff;
            border-radius: 5px;
            margin-top: 14px;

            /deep/ .el-textarea {
              height: 152px;
              cursor: pointer;
            }

            /deep/ .el-textarea__inner {
              height: 152px;
              cursor: pointer;
              padding: 10px 10px 20px;
            }

            /deep/ .el-textarea .el-textarea__inner {
              // 然后找到对应的类名，在这里将拉伸去掉即可
              resize: none;
            }
          }
        }

        .logisticswrite-div-bottom {
          display: flex;
          height: 52px;
          align-items: center;
          justify-content: flex-end;
          padding: 0 16px;
          box-sizing: border-box;
          border-top: 1px solid #d9d9d9;

          .logisticswrite-div-bottom-title {
            width: 65px;
            height: 32px;
            background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
            border-radius: 10px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
          }
        }
      }
    }

    .integral-second {
      .integral-second-table {
        /deep/ .el-table thead {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
          background: #d8d8d8;
        }

        /deep/ .el-table tr {
          height: 46px;
        }

        /deep/ .el-table__empty-text {
          line-height: 0;
        }

        /deep/ .el-table__cell {
          vertical-align: top;
        }

        .empty-block {
          margin-top: 62px;
          padding-bottom: 40px;

          .empty-block-img {
            width: 130px;
            height: 130px;
            margin: 0 auto;
          }

          .empty-block-text {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            margin-top: 10px;
            height: 17px;
            line-height: 17px;
          }
        }

        .table-ordernum {
          .table-ordernum-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
          }

          .table-ordernum-img {
            margin-top: 9px;
            width: 15px;
            height: 16px;
            cursor: pointer;
          }
        }

        .table-recipients {
          .table-recipients-phone {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
          }

          .table-recipients-address {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
            line-height: 22px;
            margin-top: 5px;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }

        .table-user {
          .table-user-name {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
          }

          .table-user-relation {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2aa4ff;
            text-decoration: underline;
            cursor: pointer;
          }
        }

        .table-status {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }

        .table-commodity {
          display: flex;
          align-content: center;

          .table-commodity-left {
            width: 70px;
            height: 70px;
            border: 1px solid #ccc;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .table-commodity-right {
            width: 196px;
            margin-left: 12px;

            .table-commodity-right-title {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #555555;
              line-height: 22px;
              word-break: break-all;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .table-commodity-right-text {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #555555;
              margin-top: 4px;
            }
          }
        }

        .table-paytype {
          .table-paytype-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
          }

          .table-paytype-img {
            width: 34px;
            height: 34px;
            margin-top: 7px;
          }
        }

        .table-operation {
          display: flex;
          align-items: center;

          .table-operation-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2aa4ff;
            text-decoration: underline;
            cursor: pointer;
          }
        }

        .table-logistics {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .integral-second-Pagination {
        height: 88px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        /deep/ .el-pagination .btn-prev {
          padding: 0;
          width: 32px;
          height: 32px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #d9d9d9;
          margin-right: 8px;
        }

        /deep/ .el-pagination .btn-next {
          padding: 0;
          width: 32px;
          height: 32px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #d9d9d9;
        }

        /deep/ .el-pager li {
          padding: 0;
          width: 32px;
          height: 32px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #d9d9d9;
          line-height: 32px;
          margin-right: 8px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
        }

        /deep/ .el-pager li.active {
          background: #000000;
          color: #ffffff;
        }

        /deep/ .el-input--mini .el-input__inner {
          height: 32px;
        }

        /deep/ .el-input__inner {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
  }

  // 解封或者冻结

  .freeze {
    .freeze-div {
      text-align: center;

      .freeze-div-img {
        width: 56px;
        height: 56px;
      }

      .freeze-div-title {
        height: 32px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
      }

      .freeze-div-text {
        width: 319px;
        height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        margin: 0 auto;
        margin-top: 2px;
      }

      .freeze-div-button {
        width: 100%;
        height: 32px;
        margin-top: 18px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        .freeze-div-button-left,
        .freeze-div-button-right {
          width: 88px;
          height: 32px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 32px;
        }

        .freeze-div-button-right {
          width: 88px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          margin-left: 10px;

          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
  }
}
</style>
